export default __webpack_public_path__ + "slices/main/assets/public/media/company-card-3@2x.9017513887b65418359b4debfc690ed0.png";